/* Monster Shoes theme runtime.
   Ported from the Round 1 handoff (Home + Product board logic) to vanilla JS: reveal, count-up, pointer FX,
   rail, My size, wishlist, quick add, fly-to-bag, bag drawer (Ajax Cart + Section Rendering), search, product page.
   Everything animated is transform/opacity only and switches off under prefers-reduced-motion. */
(function () {
  'use strict';
  var D = document, W = window;
  var cfg = {};
  try { cfg = JSON.parse(D.getElementById('ms-config').textContent); } catch (e) {}
  var R = cfg.routes || {};
  var root = D.querySelector('.ms');
  if (!root) return;

  function $(s, r) { return (r || D).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); }
  function mq(q) { try { return W.matchMedia(q).matches; } catch (e) { return false; } }
  var reduce = mq('(prefers-reduced-motion: reduce)');
  var ls = {
    get: function (k, d) { try { var v = W.localStorage.getItem(k); return v === null ? d : JSON.parse(v); } catch (e) { return d; } },
    set: function (k, v) { try { W.localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  var ICON_CHECK = '<svg class="icon s" viewBox="0 0 24 24" aria-hidden="true" style="color: var(--ms-orange)"><path d="M5 12.5l4.5 4.5L19 7"/></svg>';

  /* ---------- toast ---------- */
  var toastTimer = 0;
  function toast(msg, label, action) {
    var host = $('.ms-toasts'); if (!host) return;
    clearTimeout(toastTimer); host.innerHTML = '';
    var t = D.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status');
    t.innerHTML = ICON_CHECK + '<span></span>';
    t.querySelector('span').textContent = msg;
    if (label) {
      var b = D.createElement('button'); b.type = 'button'; b.className = 'act'; b.textContent = label;
      b.addEventListener('click', function () { host.innerHTML = ''; if (action) action(); });
      t.appendChild(b);
    }
    host.appendChild(t);
    toastTimer = setTimeout(function () { host.innerHTML = ''; }, 4000);
  }

  /* ---------- overlays: bag, search, menu ---------- */
  var OV = { bag: '#ms-drawer', search: '#ms-search', menu: '#ms-menu' };
  var openName = '', lastFocus = null;
  function openOv(name) {
    var el = $(OV[name]); if (!el) return;
    if (openName && openName !== name) closeOv(true);
    lastFocus = D.activeElement; openName = name;
    el.hidden = false;
    var sc = $('#ms-scrim'); if (sc) sc.hidden = (name === 'menu');
    D.documentElement.style.overflow = 'hidden';
    var f = name === 'search' ? $('#ms-q') : $('[data-close]', el);
    if (f) setTimeout(function () { f.focus(); }, 30);
    if (name === 'bag') fetchBag();
    if (name === 'search') renderRecent();
  }
  function closeOv(keep) {
    if (!openName) return;
    var el = $(OV[openName]); if (el) el.hidden = true;
    var sc = $('#ms-scrim'); if (sc) sc.hidden = true;
    openName = '';
    if (!keep) { D.documentElement.style.overflow = ''; if (lastFocus && lastFocus.focus) lastFocus.focus(); }
  }

  /* ---------- cart (Ajax Cart API + Section Rendering API) ---------- */
  var bagCount = parseInt(($('[data-bag-badge]') || {}).textContent, 10) || 0;
  var tickFlip = false;
  function setBagCount(n) {
    var changed = n !== bagCount; bagCount = n;
    $$('[data-bag-badge]').forEach(function (b) {
      b.textContent = String(n); b.classList.toggle('zero', n === 0);
      if (changed) { b.classList.remove('tA', 'tB'); void b.offsetWidth; tickFlip = !tickFlip; b.classList.add(tickFlip ? 'tA' : 'tB'); }
    });
    var btn = $('#ms-bag-btn'); if (btn) btn.setAttribute('aria-label', 'Bag, ' + n + ' items');
  }
  function renderBag(html) {
    var wrap = $('#shopify-section-ms-bag'); if (!wrap || !html) return;
    var tmp = D.createElement('div'); tmp.innerHTML = html;
    var fresh = tmp.querySelector('.shopify-section') || tmp;
    wrap.innerHTML = fresh.innerHTML;
    ls.set('ms.bag.html', html);
    var bag = $('.ms-bag', wrap);
    if (bag) setBagCount(parseInt(bag.getAttribute('data-bag-count'), 10) || 0);
  }
  function fetchBag() {
    return fetch((R.root || '/') + '?sections=ms-bag', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { renderBag(j['ms-bag']); })
      .catch(function () {
        var saved = ls.get('ms.bag.html', '');
        if (saved) { renderBag(saved); toast('You are offline. Showing the bag saved on this phone.'); }
      });
  }
  function offlineMsg() { return 'You are offline. Try again when you are back.'; }
  function cartPost(url, payload) {
    payload.sections = 'ms-bag';
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  var cartMap = {};
  function refreshCartMap() {
    return fetch((R.cart || '/cart') + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      cartMap = {}; (c.items || []).forEach(function (it) { cartMap[it.variant_id] = it.quantity; }); setBagCount(c.item_count || 0); return cartMap;
    }).catch(function () { return cartMap; });
  }

  /* a copy of the photo flies into the bag icon, then the bag ticks */
  var hdr = $('#ms-hdr'), hdrHidden = false;
  function fly(fromEl, done) {
    try {
      var img = fromEl && fromEl.querySelector ? fromEl.querySelector('.stage img') : null;
      var to = $$('[data-open="bag"]').filter(function (e) { return e.getBoundingClientRect().width > 0; })[0];
      if (!img || !to || !img.animate || reduce) { done(); return; }
      if (hdr && hdrHidden) { hdrHidden = false; hdr.classList.remove('hide'); }
      var a = img.getBoundingClientRect(), b = to.getBoundingClientRect();
      if (!a.width || !b.width) { done(); return; }
      var g = D.createElement('img');
      g.src = img.currentSrc || img.src; g.alt = '';
      g.style.cssText = 'position:fixed;left:' + a.left + 'px;top:' + a.top + 'px;width:' + a.width + 'px;height:' + a.height + 'px;object-fit:cover;z-index:70;pointer-events:none;border-radius:4px;background:#F0EEEC;clip-path:polygon(0 0,100% 0,100% calc(100% - 24px),calc(100% - 24px) 100%,0 100%);will-change:transform,opacity';
      D.body.appendChild(g);
      var dx = (b.left + b.width / 2) - (a.left + a.width / 2), dy = (b.top + b.height / 2) - (a.top + a.height / 2);
      var sEnd = 26 / a.width;
      var anim = g.animate([
        { transform: 'translate(0,0) scale(1)', opacity: 1, offset: 0 },
        { transform: 'translate(' + (dx * 0.45).toFixed(1) + 'px,' + (dy * 0.45 - 90).toFixed(1) + 'px) scale(' + ((1 + sEnd) / 2).toFixed(3) + ')', opacity: 1, offset: 0.55 },
        { transform: 'translate(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px) scale(' + sEnd.toFixed(3) + ')', opacity: 0.25, offset: 1 }
      ], { duration: 720, easing: 'cubic-bezier(.65,0,.35,1)', fill: 'forwards' });
      var fired = false;
      var fin = function () { if (fired) return; fired = true; if (g.parentNode) g.parentNode.removeChild(g); done(); };
      anim.onfinish = fin; setTimeout(fin, 900);
    } catch (e) { done(); }
  }

  function track(ev, data) { try { if (W.fbq) W.fbq('track', ev, data || {}); } catch (e) {} }
  function addVariant(id, label, flyFrom, name) {
    var req = cartPost(R.cartAdd, { items: [{ id: id, quantity: 1 }] });
    return new Promise(function (resolve) {
      fly(flyFrom, function () {
        req.then(function (j) {
          if (j.sections && j.sections['ms-bag']) renderBag(j.sections['ms-bag']); else fetchBag();
          track('AddToCart', { content_name: name, content_ids: [String(id)], content_type: 'product' });
          toast('Added · ' + name + (label ? ' · ' + label : ''), 'View bag', function () { openOv('bag'); });
          resolve(true);
        }).catch(function (err) {
          toast(W.navigator.onLine === false ? offlineMsg() : ((err && (err.description || err.message)) || 'Could not add that. Try again.'));
          resolve(false);
        });
      });
    });
  }

  /* ---------- My size ---------- */
  var SIZE_KEY = 'ms.mysize', sizeFlip = false;
  function getSize() { return ls.get(SIZE_KEY, ''); }
  function effSize() { return sfSel || getSize(); }
  function unitFor(card, v) { return v && /^\d{2}(\.5)?$/.test(String(v.s)) && +v.s >= 30 && +v.s <= 50 ? 'EU ' : (card.getAttribute('data-unit') || ''); }
  function pickVariant(card) {
    var vs = []; try { vs = JSON.parse(card.getAttribute('data-variants') || '[]'); } catch (e) {}
    var my = effSize(), pick = null, i;
    for (i = 0; i < vs.length; i++) if (vs[i].a && vs[i].s === my) { pick = vs[i]; break; }
    /* a chosen size never falls back to a different size */
    if (!pick && !my) for (i = 0; i < vs.length; i++) if (vs[i].a) { pick = vs[i]; break; }
    return pick;
  }
  function updateQuick(card) {
    var b = $('[data-quick]', card); if (!b) return;
    var p = pickVariant(card), unit = unitFor(card, p);
    var my = effSize(), any = false;
    if (!p && my) { try { any = JSON.parse(card.getAttribute('data-variants') || '[]').some(function (v) { return v.a; }); } catch (e) {} }
    b.textContent = p ? (card.getAttribute('data-pre') === 'true' ? 'Pre-order' : 'Quick add') + (unit && p.s ? ' · ' + unit + p.s : '') : (any ? 'Not in ' + (/^\d{2}(\.5)?$/.test(my) ? 'EU ' : '') + my : 'Sold out');
    b.disabled = !p;
  }
  function applySize(tick) {
    var s = getSize();
    $$('[data-mysize-chip]').forEach(function (a) {
      var lab = $('[data-mysize-label]', a);
      if (s) { a.classList.remove('unset'); if (lab) lab.textContent = 'EU ' + s; } else { a.classList.add('unset'); if (lab) lab.textContent = 'Set my size'; }
      if (tick) { a.classList.remove('tA', 'tB'); void a.offsetWidth; sizeFlip = !sizeFlip; a.classList.add(sizeFlip ? 'tA' : 'tB'); }
    });
    $$('[data-mysize-val]').forEach(function (el) { el.textContent = s || '--'; });
    $$('.sizegrid [data-size]').forEach(function (b) { var on = !!s && b.getAttribute('data-size') === s; b.classList.toggle('on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
    var es = effSize();
    $$('.pcard .sz').forEach(function (z) { z.classList.toggle('on', !!es && z.getAttribute('data-size') === es && !z.classList.contains('out')); });
    $$('.pcard').forEach(updateQuick);
    var note = $('[data-size-note]');
    if (note) {
      if (!s) note.textContent = 'Pick your size. We remember it on this device.';
      else {
        var cards = $$('#drops .pcard').filter(function (c) { return c.getAttribute('data-unit') === 'EU '; });
        var n = cards.filter(function (c) { return !!$('.sz[data-size="' + s + '"]:not(.out)', c); }).length;
        note.textContent = n + ' of the ' + cards.length + ' featured models are in stock in EU ' + s + ' right now.';
      }
    }
    var shop = $('[data-size-shop]'); if (shop && s) shop.setAttribute('href', '/collections/all-brands?size=' + encodeURIComponent(s));
    var wa = $('[data-alert-wa]');
    if (wa) wa.setAttribute('href', 'https://wa.me/' + cfg.whatsapp + '?text=' + encodeURIComponent('Hi Monster Shoes, please add me to the drop alerts.' + (s ? ' My size: EU ' + s + '.' : '')));
  }

  /* ---------- wishlist (this device) ---------- */
  function wishList() { return ls.get('ms.wish', []); }
  function paintWish(btn) {
    var h = btn.getAttribute('data-wish'), on = wishList().indexOf(h) >= 0, svg = $('svg', btn), name = btn.getAttribute('data-name') || 'this product';
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', (on ? 'Remove ' : 'Add ') + name + (on ? ' from wishlist' : ' to wishlist'));
    if (svg) {
      svg.style.fill = on ? 'var(--ms-orange)' : 'none';
      if (btn.classList.contains('ibtn')) svg.style.stroke = on ? 'var(--ms-orange)' : '#FFFFFF';
    }
  }
  function toggleWish(btn) {
    var h = btn.getAttribute('data-wish'), list = wishList(), i = list.indexOf(h), name = btn.getAttribute('data-name') || 'Saved';
    if (i >= 0) { list.splice(i, 1); toast('Removed from wishlist'); } else { list.push(h); toast('Saved to wishlist · ' + name); }
    ls.set('ms.wish', list); $$('[data-wish="' + h + '"]').forEach(paintWish);
  }

  /* ---------- reveal + count-up ---------- */
  var counted = false;
  function startCount() {
    if (counted) return; counted = true;
    var els = $$('.btile .ct[data-count]'); if (!els.length || reduce) return;
    var t0 = performance.now();
    (function step() {
      var p = Math.min(1, (performance.now() - t0) / 1100), e = 1 - Math.pow(1 - p, 3);
      els.forEach(function (el) { el.textContent = String(Math.round(parseInt(el.getAttribute('data-count'), 10) * e)); });
      if (p < 1) requestAnimationFrame(step);
    })();
  }
  function initReveal(scope) {
    var els = $$('.rv:not(.on)', scope);
    if (!els.length) return;
    var showAll = function () { els.forEach(function (el) { el.classList.add('on'); }); startCount(); };
    if (typeof IntersectionObserver === 'undefined' || reduce) { showAll(); return; }
    var fired = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('on'); io.unobserve(en.target); fired = true;
        if (en.target.id === 'brands') startCount();
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (el) { io.observe(el); });
    var se = D.scrollingElement || D.documentElement;
    if (se.scrollHeight <= W.innerHeight + 4) showAll();
    setTimeout(function () { if (!fired) showAll(); }, 2500);
  }

  /* ---------- pointer FX, header hide (outside any state: written straight to styles) ---------- */
  function initFx() {
    var spot = $('.spot'), ring = $('.ring');
    var fx = { x: 0, y: 0, tx: 0, ty: 0, sx: 0, sy: 0, hx: 0, hy: 0, on: false, raf: 0, card: null, big: false, sk: 0, skT: 0, lastSL: 0, lastT: 0, lastY: 0 };
    var ghost = $('.ghostw'), heroCard = $('.hero-card'), rail = $('[data-rail]');
    function untilt() { var c = fx.card; if (!c) return; ['--rx', '--ry', '--tl'].forEach(function (k) { c.style.removeProperty(k); }); fx.card = null; }
    // header hides on scroll-down on phones, returns on scroll-up
    W.addEventListener('scroll', function () {
      if (!hdr) return;
      var y = W.scrollY || 0, phone = mq('(max-width: 767px)');
      if (phone && y > fx.lastY + 2 && y > 160 && !hdrHidden) { hdrHidden = true; hdr.classList.add('hide'); }
      else if ((y < fx.lastY - 2 || y < 80 || !phone) && hdrHidden) { hdrHidden = false; hdr.classList.remove('hide'); }
      fx.lastY = y;
    }, { passive: true });
    if (reduce || cfg.fx === false || !mq('(hover: hover) and (pointer: fine)')) return;
    function loop() {
      fx.raf = 0; var busy = false;
      fx.sx += (fx.tx - fx.sx) * 0.08; fx.sy += (fx.ty - fx.sy) * 0.08;
      fx.hx += (fx.tx - fx.hx) * 0.35; fx.hy += (fx.ty - fx.hy) * 0.35;
      if (spot) spot.style.transform = 'translate3d(' + fx.sx.toFixed(1) + 'px,' + fx.sy.toFixed(1) + 'px,0)';
      if (ring) ring.style.transform = 'translate3d(' + fx.hx.toFixed(1) + 'px,' + fx.hy.toFixed(1) + 'px,0)';
      if (Math.abs(fx.tx - fx.sx) > 0.5 || Math.abs(fx.ty - fx.sy) > 0.5) busy = true;
      if (ghost || heroCard) {
        var w = W.innerWidth || 1, h = W.innerHeight || 1, nx = (fx.tx / w) * 2 - 1, ny = (fx.ty / h) * 2 - 1;
        fx.x += (nx - fx.x) * 0.06; fx.y += (ny - fx.y) * 0.06;
        if (ghost) ghost.style.transform = 'translate3d(' + (fx.x * 22).toFixed(2) + 'px,' + (fx.y * 22).toFixed(2) + 'px,0)';
        if (heroCard && !fx.card) { heroCard.style.setProperty('--ry', (fx.x * 4).toFixed(2) + 'deg'); heroCard.style.setProperty('--rx', (-fx.y * 4).toFixed(2) + 'deg'); }
        if (Math.abs(nx - fx.x) > 0.002 || Math.abs(ny - fx.y) > 0.002) busy = true;
      }
      if (Math.abs(fx.sk) > 0.01 || Math.abs(fx.skT) > 0.01) {
        fx.sk += (fx.skT - fx.sk) * 0.18; fx.skT *= 0.82;
        if (rail) rail.style.setProperty('--sk', fx.sk.toFixed(2) + 'deg');
        busy = true;
      } else if (fx.sk !== 0) { fx.sk = 0; if (rail) rail.style.setProperty('--sk', '0deg'); }
      if (busy && fx.on) fx.raf = requestAnimationFrame(loop);
    }
    function kick() { if (!fx.raf) fx.raf = requestAnimationFrame(loop); }
    root.addEventListener('pointermove', function (e) {
      fx.tx = e.clientX; fx.ty = e.clientY;
      if (!fx.on) { fx.on = true; fx.sx = fx.hx = fx.tx; fx.sy = fx.hy = fx.ty; if (spot) spot.style.opacity = '1'; if (ring) ring.style.opacity = '1'; }
      var card = e.target && e.target.closest ? e.target.closest('.pcard, .cat, .btile, .hero-card, .main') : null;
      if (card !== fx.card) { untilt(); fx.card = card; if (card) card.style.setProperty('--tl', '1'); }
      if (card) {
        var r = card.getBoundingClientRect(), px = (e.clientX - r.left) / Math.max(1, r.width), py = (e.clientY - r.top) / Math.max(1, r.height);
        var amp = card.classList.contains('btile') || card.classList.contains('hero-card') ? 5 : (card.classList.contains('main') ? 3.5 : 7);
        card.style.setProperty('--ry', ((px - 0.5) * 2 * amp).toFixed(2) + 'deg');
        card.style.setProperty('--rx', ((0.5 - py) * 2 * amp).toFixed(2) + 'deg');
        card.style.setProperty('--gx', (px * 100).toFixed(1) + '%'); card.style.setProperty('--gy', (py * 100).toFixed(1) + '%');
      }
      var big = !!(e.target && e.target.closest && e.target.closest('a, button, input, [role="button"], .size, .chip, .thumb'));
      if (big !== fx.big) { fx.big = big; if (ring) ring.classList.toggle('big', big); }
      kick();
    }, { passive: true });
    root.addEventListener('pointerleave', function () {
      fx.on = false; untilt();
      if (spot) spot.style.opacity = '0'; if (ring) ring.style.opacity = '0';
      if (heroCard) { heroCard.style.removeProperty('--rx'); heroCard.style.removeProperty('--ry'); }
      if (ghost) ghost.style.transform = ''; fx.x = fx.y = 0;
    });
    root.addEventListener('pointerdown', function () { if (ring) ring.classList.add('down'); }, { passive: true });
    W.addEventListener('pointerup', function () { if (ring) ring.classList.remove('down'); }, { passive: true });
    if (rail) rail.addEventListener('scroll', function () {
      var now = performance.now(), sl = rail.scrollLeft, dt = Math.max(8, now - fx.lastT), v = (sl - fx.lastSL) / dt;
      fx.lastT = now; fx.lastSL = sl; fx.skT = Math.max(-9, Math.min(9, v * -6)); fx.on = true; kick();
    }, { passive: true });
  }

  /* ---------- rails: arrows + drag ---------- */
  function initRails(scope) {
    $$('[data-rail]', scope).forEach(function (rail) {
      if (rail.__ms) return; rail.__ms = true;
      var sec = rail.closest('section') || D;
      var prev = $('[data-rail-prev]', sec), next = $('[data-rail-next]', sec);
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -rail.clientWidth * 0.8, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: rail.clientWidth * 0.8, behavior: 'smooth' }); });
      var drag = null, just = false;
      rail.addEventListener('mousedown', function (e) { if (e.button !== 0) return; drag = { x: e.clientX, sl: rail.scrollLeft, moved: false }; rail.classList.add('dragging'); });
      rail.addEventListener('mousemove', function (e) { if (!drag) return; var dx = e.clientX - drag.x; if (Math.abs(dx) > 4) drag.moved = true; rail.scrollLeft = drag.sl - dx; });
      var up = function () { if (!drag) return; just = drag.moved; drag = null; rail.classList.remove('dragging'); setTimeout(function () { just = false; }, 50); };
      rail.addEventListener('mouseup', up); rail.addEventListener('mouseleave', up);
      rail.addEventListener('click', function (e) { if (just) { e.preventDefault(); e.stopPropagation(); } }, true);
    });
  }

  /* ---------- search ---------- */
  var searchTimer = 0, searchSeq = 0;
  function recent() { return ls.get('ms.recent.q', []); }
  function pushRecent(q) { q = (q || '').trim(); if (!q) return; var l = recent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); }); l.unshift(q); ls.set('ms.recent.q', l.slice(0, 5)); }
  function renderRecent() {
    var l = recent(), box = $('#ms-recent'), list = $('#ms-recent-list'); if (!box || !list) return;
    list.innerHTML = '';
    l.forEach(function (q) { var b = D.createElement('button'); b.type = 'button'; b.className = 'chip'; b.setAttribute('data-q', q); b.textContent = q; list.appendChild(b); });
    box.style.display = l.length ? 'flex' : 'none';
  }
  function runSearch(q) {
    var idle = $('#ms-search-idle'), res = $('#ms-search-results'), none = $('#ms-search-none');
    q = (q || '').trim();
    if (!q) { idle.style.display = 'flex'; res.hidden = true; none.hidden = true; return; }
    var seq = ++searchSeq;
    var sizeQ = /^\d{2}(\.5)?$/.test(q) && +q >= 30 && +q <= 60, sizeTotal = 0;
    var url = sizeQ ? '/collections/all-brands?view=app&page=1' : (R.suggest || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,vendor';
    (sizeQ ? loadCatalogue() : fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); })).then(function (j) {
      if (seq !== searchSeq) return;
      var items = (((j || {}).resources || {}).results || {}).products || [];
      if (sizeQ) {
        // a size search lists every product (all pages of All Brands) that has that exact size in stock
        var hits = ((j || {}).products || []).filter(function (c) { return (c.variants || []).some(function (v) { return v.s === q && v.a; }); });
        sizeTotal = hits.length;
        items = hits.slice(0, 12)
          .map(function (c) { return { url: '/products/' + c.handle, title: c.brand + ' ' + c.name, image: c.image, price: (c.price / 100).toFixed(2), available: c.available }; });
      }
      idle.style.display = 'none';
      if (!items.length) { res.hidden = true; none.hidden = false; $('#ms-none-q').textContent = '“' + q + '”'; return; }
      none.hidden = true; res.hidden = false; res.innerHTML = '';
      var lab = D.createElement('span'); lab.className = 'eyebrow'; var shownN = sizeQ ? sizeTotal : items.length; lab.textContent = shownN + (shownN === 1 ? ' result' : ' results'); res.appendChild(lab);
      items.forEach(function (p) {
        var a = D.createElement('a'); a.className = 'result'; a.href = p.url;
        var st = D.createElement('div'); st.className = 'stage'; st.style.cssText = 'width:56px;height:56px;flex:none';
        if (p.image) { var im = D.createElement('img'); im.src = p.image; im.alt = ''; st.appendChild(im); }
        var mid = D.createElement('div'); mid.style.cssText = 'flex:1;min-width:0;display:flex;flex-direction:column';
        var nm = D.createElement('span'); nm.style.cssText = "font-family:Saira,system-ui,sans-serif;font-stretch:112%;font-weight:700;font-size:14px;letter-spacing:.02em;text-transform:uppercase;color:#FFFFFF"; nm.textContent = p.title;
        var sub = D.createElement('span'); sub.className = 'small'; sub.textContent = p.available === false ? 'Sold out' : 'In stock';
        mid.appendChild(nm); mid.appendChild(sub);
        var pr = D.createElement('span'); pr.style.cssText = "font-family:Saira,system-ui,sans-serif;font-weight:700;font-size:15px;font-variant-numeric:tabular-nums;color:#FFFFFF";
        pr.textContent = p.price ? '$' + String(p.price).replace(/\.00$/, '') : '';
        a.appendChild(st); a.appendChild(mid); a.appendChild(pr);
        a.addEventListener('click', function () { pushRecent(q); });
        res.appendChild(a);
      });
      if (sizeQ && sizeTotal > items.length) {
        var all = D.createElement('a'); all.className = 'btn2 sm'; all.href = '/collections/all-brands?size=' + encodeURIComponent(q);
        all.textContent = 'See all ' + sizeTotal + ' in EU ' + q; all.style.alignSelf = 'flex-start'; res.appendChild(all);
      }
    }).catch(function () {});
  }

  /* ---------- drop alerts ---------- */
  function initAlerts() {
    var form = $('#ms-alert'); if (!form || form.__ms) return; form.__ms = true;
    form.addEventListener('submit', function (e) {
      var inp = $('#al', form); if (!inp) return;
      var v = inp.value.trim();
      if (v && v.indexOf('@') < 0 && /^\+?[\d\s()-]{7,}$/.test(v)) {
        e.preventDefault();
        var s = getSize();
        W.open('https://wa.me/' + cfg.whatsapp + '?text=' + encodeURIComponent('Hi Monster Shoes, please add me to the drop alerts. My number: ' + v + (s ? '. My size: EU ' + s : '')), '_blank', 'noopener');
        toast('Opened WhatsApp. Send the message to join the drop alerts.');
        return;
      }
      var b = $('[data-alert-btn]', form);
      if (b) { b.setAttribute('aria-busy', 'true'); b.innerHTML = '<span class="dots" aria-hidden="true"><i></i><i></i></span>Sending'; }
    });
  }

  /* ---------- cards: quick add, notify ---------- */
  function initCards(scope) { $$('.pcard', scope).forEach(updateQuick); $$('[data-wish]', scope).forEach(paintWish); }

  /* ---------- product page ---------- */
  function initPdp() {
    var pdp = $('[data-pdp]'); if (!pdp || pdp.__ms) return; pdp.__ms = true; track('ViewContent', { content_name: (($('h1', pdp) || {}).textContent || '').trim(), content_type: 'product' });
    var raw = $('[data-pdp-json]'); if (!raw) return;
    var data = JSON.parse(raw.textContent), photos = data.photos || [], vars = data.variants || [];
    var st = { img: 0, flip: false, vid: data.selected, adding: false, notified: {} };
    var mainImg = $('.main .stage img', pdp), thumbs = $$('.thumb', pdp), dots = $$('.dots i', pdp), rail = $('.gal-rail', pdp);
    var sizeBtns = $$('.size', pdp), msg = $('[data-size-msg]', pdp), notifyBtn = $('[data-pdp-notify]', pdp), notifyLabel = $('[data-notify-label]', pdp);
    var ctas = $$('[data-cta]'), outBtns = $$('[data-cta-out]'), priceEls = $$('[data-pdp-price]'), sizeLabels = $$('[data-pdp-size]');
    var waBtn = $('[data-pdp-wa]', pdp);
    // Sticky buy bar: only once the real Add to bag block has scrolled off the top, so it never covers the sizes
    var sbar = $('.stickybar'), buyBlock = ctas[0] && ctas[0].parentElement;
    if (sbar && buyBlock && typeof IntersectionObserver !== 'undefined') {
      new IntersectionObserver(function (es) {
        var e = es[es.length - 1];
        sbar.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.bottom < 0);
      }).observe(buyBlock);
    }
    function curVar() { for (var i = 0; i < vars.length; i++) if (vars[i].id === st.vid) return vars[i]; return vars[0]; }
    function vLabel(v) { return data.single ? '' : data.unit + v.title; }
    function inBagFull(v) { var q = cartMap[v.id] || 0; return q > 0 && q >= (v.max || 99); }
    function waUrl(v) {
      var t = 'Hi Monster Shoes, I am interested in ' + data.title + (data.single ? '' : ' in ' + vLabel(v)) + '. ' + data.url;
      return 'https://wa.me/' + cfg.whatsapp + '?text=' + encodeURIComponent(t);
    }
    function render() {
      var v = curVar(), out = !v.available;
      sizeBtns.forEach(function (b) { var on = parseInt(b.getAttribute('data-variant'), 10) === st.vid; b.classList.toggle('on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
      var label = vLabel(v);
      if (msg) {
        if (out) msg.textContent = st.notified[v.id] ? 'We will message you when ' + label + ' is back.' : (label ? label + ' is sold out.' : 'Sold out.');
        else msg.textContent = (label ? label + ' · ' : '') + (v.pre ? 'pre-order' : v.last ? 'last pair' : v.one ? 'only 1 left' : 'in stock');
      }
      if (notifyBtn) notifyBtn.hidden = !out;
      if (notifyLabel) notifyLabel.textContent = st.notified[v.id] ? 'You’re on the list' : 'Notify me';
      sizeLabels.forEach(function (el) { el.textContent = data.single ? '' : v.title; });
      priceEls.forEach(function (el) { el.textContent = v.price; });
      var full = inBagFull(v);
      ctas.forEach(function (b) {
        var short = b.hasAttribute('data-cta-short');
        b.hidden = out; b.classList.toggle('is-adding', st.adding);
        var tx = b.querySelector('[data-cta-text]') || b;
        var t = st.adding ? 'Lacing up' : (full ? (short ? 'In your bag' : 'In your bag' + (label ? ' · ' + label : '')) : (short ? (v.pre ? 'Pre-order' : 'Add to bag') : (v.pre ? 'Pre-order · ' : 'Add to bag · ') + v.price));
        if (b.firstChild && b.firstChild.nodeType === 3) b.firstChild.nodeValue = t; else if (b.querySelector('[data-cta-text]')) b.querySelector('[data-cta-text]').textContent = t;
      });
      outBtns.forEach(function (b) { b.hidden = !out; });
      if (waBtn) waBtn.setAttribute('href', waUrl(v));
    }
    sizeBtns.forEach(function (b) { b.addEventListener('click', function () { st.vid = parseInt(b.getAttribute('data-variant'), 10); render(); }); });
    ctas.forEach(function (b) { b.addEventListener('click', function () {
      var v = curVar(); if (st.adding || !v.available) return;
      if (inBagFull(v)) { openOv('bag'); return; }
      st.adding = true; render();
      setTimeout(function () {
        addVariant(v.id, vLabel(v), $('.main', pdp) || $('.gal-rail', pdp), data.name).then(function () { st.adding = false; refreshCartMap().then(render); });
      }, reduce ? 0 : 560);
    }); });
    $$('[data-pdp-notify], [data-cta-out]').forEach(function (b) { b.addEventListener('click', function () {
      var v = curVar(); st.notified[v.id] = true; render();
      W.open('https://wa.me/' + cfg.whatsapp + '?text=' + encodeURIComponent('Hi Monster Shoes, please message me when ' + data.title + (data.single ? '' : ' in ' + vLabel(v)) + ' is back. ' + data.url), '_blank', 'noopener');
      toast('Restock alert · ' + (vLabel(v) || data.name));
    }); });

    function setImg(i, fromRail) {
      st.img = Math.max(0, Math.min(photos.length - 1, i));
      thumbs.forEach(function (t, k) { var on = k === st.img; t.classList.toggle('on', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
      dots.forEach(function (d, k) { d.classList.toggle('on', k === st.img); });
      if (mainImg && photos[st.img]) { st.flip = !st.flip; mainImg.className = st.flip ? 'fa' : 'fb'; mainImg.removeAttribute('srcset'); mainImg.src = photos[st.img].src; mainImg.alt = photos[st.img].alt; }
      if (rail && !fromRail && rail.clientWidth) rail.scrollTo({ left: st.img * rail.clientWidth, behavior: 'smooth' });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { setImg(k); }); });
    if (rail) rail.addEventListener('scroll', function () { var i = Math.round(rail.scrollLeft / Math.max(1, rail.clientWidth)); if (i !== st.img) setImg(i, true); }, { passive: true });

    // zoom lightbox: 2x, pan with the pointer, click or Esc closes
    var zoom = null;
    function openZoom() {
      if (zoom || !photos.length) return;
      zoom = D.createElement('div'); zoom.className = 'zoom-ov'; zoom.setAttribute('role', 'dialog'); zoom.setAttribute('aria-label', 'Zoomed photo, move to pan, click to close');
      var im = D.createElement('img'); im.src = photos[st.img].zoom || photos[st.img].src; im.alt = photos[st.img].alt;
      var cl = D.createElement('button'); cl.type = 'button'; cl.className = 'ibtn zclose'; cl.setAttribute('aria-label', 'Close zoom'); cl.innerHTML = '<svg class="icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      var hint = D.createElement('span'); hint.className = 'small zhint'; hint.textContent = 'Move to pan · click or Esc to close';
      zoom.appendChild(im); zoom.appendChild(cl); zoom.appendChild(hint); root.appendChild(zoom);
      D.documentElement.style.overflow = 'hidden';
      function pan(cx, cy) {
        var r = zoom.getBoundingClientRect(), px = Math.max(0, Math.min(1, (cx - r.left) / Math.max(1, r.width))), py = Math.max(0, Math.min(1, (cy - r.top) / Math.max(1, r.height)));
        var ow = im.offsetWidth || r.width * 2, oh = im.offsetHeight || r.height * 2;
        im.style.transform = 'translate(' + (-(px * Math.max(0, ow - r.width))).toFixed(1) + 'px,' + (-(py * Math.max(0, oh - r.height))).toFixed(1) + 'px)';
      }
      zoom.addEventListener('mousemove', function (e) { pan(e.clientX, e.clientY); });
      zoom.addEventListener('touchmove', function (e) { var t = e.touches && e.touches[0]; if (t) pan(t.clientX, t.clientY); }, { passive: true });
      zoom.addEventListener('click', closeZoom);
      cl.focus();
    }
    function closeZoom() { if (!zoom) return; zoom.remove(); zoom = null; D.documentElement.style.overflow = openName ? 'hidden' : ''; }
    $$('[data-zoom]', pdp).forEach(function (el) { el.addEventListener('click', openZoom); });
    W.__msCloseZoom = function () { if (zoom) { closeZoom(); return true; } return false; };

    // accordions: one open at a time
    var heads = $$('.acc .hd', pdp);
    heads.forEach(function (h) { h.addEventListener('click', function () {
      var open = h.getAttribute('aria-expanded') === 'true';
      heads.forEach(function (x) { x.setAttribute('aria-expanded', 'false'); var c = $('.chev', x); if (c) c.classList.remove('open'); var bd = x.parentNode.querySelector('.bd'); if (bd) bd.hidden = true; });
      if (!open) { h.setAttribute('aria-expanded', 'true'); var c2 = $('.chev', h); if (c2) c2.classList.add('open'); var bd2 = h.parentNode.querySelector('.bd'); if (bd2) bd2.hidden = false; }
    }); });

    // recently viewed: remember this product, show the others
    var rv = ls.get('ms.recent.p', []).filter(function (h) { return h !== data.handle; });
    var list = [data.handle].concat(rv).slice(0, 8); ls.set('ms.recent.p', list);
    var box = $('[data-recent]'), railEl = $('[data-recent-rail]');
    if (box && railEl) {
      if (!rv.length) { box.hidden = true; } else {
        Promise.all(rv.slice(0, 4).map(function (h) { return fetch((R.root || '/') + 'products/' + h + '.js').then(function (r) { return r.json(); }).catch(function () { return null; }); })).then(function (ps) {
          ps = ps.filter(Boolean); if (!ps.length) { box.hidden = true; return; }
          ps.forEach(function (p) {
            var c = D.createElement('div'); c.className = 'pcard' + (p.available ? '' : ' soldout');
            var a = D.createElement('a'); a.href = p.url;
            var s = D.createElement('div'); s.className = 'stage'; s.style.aspectRatio = '1 / 1';
            if (p.featured_image) { var im = D.createElement('img'); im.src = p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_480x$1$2'); im.alt = p.title; im.loading = 'lazy'; s.appendChild(im); }
            var m = D.createElement('div'); m.className = 'meta';
            var n = D.createElement('span'); n.className = 'name'; n.style.fontSize = '13px'; n.textContent = p.title;
            var pr = D.createElement('span'); pr.className = 'pr'; pr.style.fontSize = '14px'; pr.textContent = p.available ? '$' + (p.price / 100).toString().replace(/\.0+$/, '') : 'Sold out';
            m.appendChild(n); m.appendChild(pr); a.appendChild(s); a.appendChild(m); c.appendChild(a); railEl.appendChild(c);
          });
          box.hidden = false;
        });
      }
    }
    refreshCartMap().then(render); render();
  }


  var catalogue = null;
  function loadCatalogue() {
    if (catalogue) return catalogue;
    var all = [];
    function page(n) {
      return fetch('/collections/all-brands?view=app&page=' + n, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
        all = all.concat(j.products || []);
        return n < (j.pages || 1) ? page(n + 1) : { products: all };
      });
    }
    catalogue = page(1).catch(function (e) { catalogue = null; throw e; });
    return catalogue;
  }

  /* ---------- collection: filter by size (reads every variant of every card on the page) ---------- */
  var SF_ORDER = ['XXXS','XXS','XS','S','SMALL','M','MEDIUM','L','LARGE','XL','X-LARGE','XXL','2XL','XXXL','3XL','4XL'];
  function sfSort(a, b) {
    var na = parseFloat(a), nb = parseFloat(b);
    if (!isNaN(na) && !isNaN(nb) && String(na) === a && String(nb) === b) return na - nb;
    var ia = SF_ORDER.indexOf(a.toUpperCase()), ib = SF_ORDER.indexOf(b.toUpperCase());
    if (ia >= 0 && ib >= 0) return ia - ib;
    if (ia >= 0) return -1; if (ib >= 0) return 1;
    return a < b ? -1 : a > b ? 1 : 0;
  }
  function sfKind(s) {
    if (/^\d{2}(\.5)?$/.test(s) && +s >= 30 && +s <= 50) return 'shoes';
    if (/^(XXXS|XXS|XS|S|M|L|XL|XXL|XXXL|[2-5]XL|SMALL|MEDIUM|LARGE|X-LARGE|XX-LARGE|S-M|M-L|L-XL|ONE SIZE)$/i.test(s)) return 'clothing';
    return '';
  }
  var sfSel = '', sfLast = false;
  function sfCards() { var g = $('[data-grid]'); return g ? $$('.pcard', g) : []; }
  function sfHas(card, size) {
    var vs = []; try { vs = JSON.parse(card.getAttribute('data-variants') || '[]'); } catch (e) {}
    for (var i = 0; i < vs.length; i++) if (vs[i].a && String(vs[i].s) === size) return true;
    return false;
  }
  function sfApply() {
    var cards = sfCards(), shown = 0;
    cards.forEach(function (c) {
      var ok = (!sfSel || sfHas(c, sfSel)) && (!sfLast || c.getAttribute('data-last') === 'true');
      c.style.display = ok ? '' : 'none'; if (ok) shown++;
    });
    var cnt = $('[data-sf-count]'), total = cnt ? cnt.getAttribute('data-total') : '';
    if (cnt) cnt.textContent = (sfSel || sfLast) ? shown + (sfLast ? (shown === 1 ? ' last pair' : ' last pairs') : (shown === 1 ? ' product' : ' products')) + (sfSel ? ' in ' + sfSel : '') : total + ' products';
    var empty = $('[data-sf-empty]'); if (empty) empty.hidden = !((sfSel || sfLast) && shown === 0);
    var clr = $('[data-sf-clear]'); if (clr) clr.hidden = !(sfSel || sfLast);
    applySize(false);
    $$('[data-sf-last]').forEach(function (b) { b.classList.toggle('on', sfLast); b.setAttribute('aria-pressed', sfLast ? 'true' : 'false'); });
    $$('[data-sf]').forEach(function (b) { var on = b.getAttribute('data-sf') === sfSel; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    try {
      var u = new URL(W.location.href);
      if (sfSel) u.searchParams.set('size', sfSel); else u.searchParams.delete('size');
      if (sfLast) u.searchParams.set('stock', 'last'); else u.searchParams.delete('stock');
      W.history.replaceState(null, '', u.toString());
    } catch (e) {}
  }
  function initSizeFilter() {
    var bar = $('[data-sfilter]'), host = bar && $('[data-sf-groups]', bar); if (!bar || !host) return;
    var cards = sfCards(), groups = { shoes: {}, clothing: {} }, any = false;
    cards.forEach(function (c) {
      var vs = []; try { vs = JSON.parse(c.getAttribute('data-variants') || '[]'); } catch (e) {}
      var seen = {};
      vs.forEach(function (v) {
        var s = String(v.s || ''), g = sfKind(s);
        if (!v.a || !s || !g || seen[s]) return;
        seen[s] = 1; g = groups[g]; g[s] = (g[s] || 0) + 1; any = true;
      });
    });
    if (!any) return;
    host.innerHTML = '';
    var lw = D.createElement('div'); lw.className = 'sf-group';
    var lb = D.createElement('button'); lb.type = 'button'; lb.className = 'size'; lb.setAttribute('data-sf-last', ''); lb.setAttribute('aria-pressed', 'false'); lb.textContent = 'Last pairs only';
    lw.appendChild(lb); host.appendChild(lw);
    [['shoes', 'Shoes · EU'], ['clothing', 'Clothing']].forEach(function (pair) {
      var keys = Object.keys(groups[pair[0]]).sort(sfSort); if (!keys.length) return;
      var wrap = D.createElement('div'); wrap.className = 'sf-group';
      var lab = D.createElement('span'); lab.className = 'small sf-lab'; lab.textContent = pair[1]; wrap.appendChild(lab);
      var row = D.createElement('div'); row.className = 'sizegrid';
      keys.forEach(function (k) {
        var b = D.createElement('button'); b.type = 'button'; b.className = 'size'; b.setAttribute('data-sf', k); b.setAttribute('aria-pressed', 'false');
        b.setAttribute('aria-label', 'Size ' + k + ', ' + groups[pair[0]][k] + ' in stock');
        b.appendChild(D.createTextNode(k));
        var n = D.createElement('small'); n.className = 'sf-n'; n.textContent = groups[pair[0]][k]; b.appendChild(n);
        row.appendChild(b);
      });
      wrap.appendChild(row); host.appendChild(wrap);
    });
    bar.hidden = false;
    var q = ''; try { q = new URL(W.location.href).searchParams.get('size') || ''; } catch (e) {}
    sfSel = /^[A-Za-z0-9. \-]{1,12}$/.test(q) ? q : '';
    try { sfLast = new URL(W.location.href).searchParams.get('stock') === 'last'; } catch (e) {}
    sfApply();
  }

  /* ---------- collection: "Load more" adds the next page to the grid instead of leaving the page ---------- */
  function loadMore(btn) {
    if (btn.__busy) return; btn.__busy = true;
    var url = btn.getAttribute('href'), label = btn.textContent;
    btn.textContent = 'Loading';
    fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('status ' + r.status); return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var grid = $('[data-grid]'), more = $('[data-more]'), ngrid = doc.querySelector('[data-grid]'), nmore = doc.querySelector('[data-more]');
      if (!grid || !ngrid) throw new Error('no grid');
      $$('.pcard', ngrid).forEach(function (c) { grid.appendChild(D.importNode(c, true)); });
      initCards(grid); applySize(false); if ($('[data-sfilter]')) initSizeFilter();
      if (more) { if (nmore) more.innerHTML = nmore.innerHTML; else more.parentNode.removeChild(more); }
    }).catch(function () { btn.__busy = false; btn.textContent = label; W.location.href = url; });
  }

  /* ---------- install as an app + connection state ---------- */
  var isApp = D.documentElement.classList.contains('ms-app');
  var installEvt = null;
  W.addEventListener('beforeinstallprompt', function (e) { e.preventDefault(); installEvt = e; });
  W.addEventListener('appinstalled', function () {
    installEvt = null; $$('[data-install]').forEach(function (el) { el.hidden = true; });
    toast('Monster Shoes is on your home screen');
  });
  function initInstall() { $$('[data-install]').forEach(function (el) { el.hidden = isApp; }); }
  function doInstall() {
    if (installEvt) { var ev = installEvt; installEvt = null; ev.prompt(); return; }
    var ua = W.navigator.userAgent || '';
    var ios = /iphone|ipad|ipod/i.test(ua) || (W.navigator.platform === 'MacIntel' && W.navigator.maxTouchPoints > 1);
    toast(ios ? 'Tap Share, then Add to Home Screen' : 'Open your browser menu, then Install app or Add to Home screen');
  }
  W.addEventListener('offline', function () { toast('You are offline. Your bag, size and saved shoes stay on this phone.'); });
  W.addEventListener('online', function () { toast('Back online'); refreshCartMap(); if (openName === 'bag') fetchBag(); });

  /* ---------- white screen / dark screen ---------- */
  function applyTheme(light) {
    var h = D.documentElement;
    if (light) h.setAttribute('data-theme', 'light'); else h.removeAttribute('data-theme');
    var m = $('meta[name="theme-color"]'); if (m) m.setAttribute('content', light ? '#FFFFFF' : '#110F0D');
    $$('[data-theme-toggle]').forEach(function (b) {
      b.setAttribute('aria-pressed', light ? 'true' : 'false');
      if (!b.querySelector('[data-theme-label]')) b.setAttribute('aria-label', light ? 'Switch to dark screen' : 'Switch to white screen');
    });
    $$('[data-theme-label]').forEach(function (l) { l.textContent = light ? 'Dark screen' : 'White screen'; });
  }
  function setTheme(light) { try { W.localStorage.setItem('ms.theme', light ? 'light' : 'dark'); } catch (e) {} applyTheme(light); }
  function initTheme() { applyTheme(D.documentElement.getAttribute('data-theme') === 'light'); }

  /* ---------- wiring ---------- */
  D.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var tt = t.closest('[data-theme-toggle]'); if (tt) { setTheme(D.documentElement.getAttribute('data-theme') !== 'light'); return; }
    var sf = t.closest('[data-sf]'); if (sf) { var k = sf.getAttribute('data-sf'); sfSel = sfSel === k ? '' : k; sfApply(); return; }
    if (t.closest('[data-sf-last]')) { sfLast = !sfLast; sfApply(); return; }
    if (t.closest('[data-sf-clear]')) { sfSel = ''; sfLast = false; sfApply(); return; }
    var lm = t.closest('[data-loadmore]'); if (lm) { e.preventDefault(); loadMore(lm); return; }
    var ins = t.closest('[data-install]'); if (ins) { e.preventDefault(); doInstall(); return; }
    var op = t.closest('[data-open]'); if (op) { e.preventDefault(); openOv(op.getAttribute('data-open')); return; }
    if (t.closest('[data-close]')) { closeOv(); return; }
    var q = t.closest('[data-q]'); if (q) { var inp = $('#ms-q'); if (inp) { inp.value = q.getAttribute('data-q'); runSearch(inp.value); inp.focus(); } return; }
    var z = t.closest('.sizegrid [data-size]');
    if (z) { ls.set(SIZE_KEY, z.getAttribute('data-size')); applySize(true); return; }
    var w = t.closest('[data-wish]'); if (w) { e.preventDefault(); toggleWish(w); return; }
    var qa = t.closest('[data-quick]');
    if (qa) {
      e.preventDefault(); var card = qa.closest('.pcard'), p = pickVariant(card); if (!p) return;
      var unit = unitFor(card, p), name = (card.querySelector('.name') || {}).textContent || card.getAttribute('data-title');
      addVariant(p.id, unit && p.s ? unit + p.s : '', card, name); return;
    }
    var nf = t.closest('[data-notify]');
    if (nf) {
      e.preventDefault(); var c2 = nf.closest('.pcard');
      W.open('https://wa.me/' + cfg.whatsapp + '?text=' + encodeURIComponent('Hi Monster Shoes, please message me when ' + c2.getAttribute('data-title') + ' is back. ' + W.location.origin + c2.getAttribute('data-url')), '_blank', 'noopener');
      toast('Restock alert · ' + c2.getAttribute('data-title')); return;
    }
    var act = t.closest('.ms-bag [data-act]');
    if (act) {
      var line = act.closest('.line'), key = line.getAttribute('data-key'), qty = parseInt(line.getAttribute('data-qty'), 10) || 1, a = act.getAttribute('data-act');
      var nq = a === 'remove' ? 0 : (a === 'inc' ? qty + 1 : qty - 1);
      cartPost((R.cartChange || '/cart/change.js'), { id: key, quantity: nq }).then(function (j) { renderBag(j.sections && j.sections['ms-bag']); }).catch(function (err) { toast(W.navigator.onLine === false ? offlineMsg() : ((err && (err.description || err.message)) || 'Could not change that.')); fetchBag(); });
    }
  });
  D.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (W.__msCloseZoom && W.__msCloseZoom()) return;
    closeOv();
  });
  var sq = $('#ms-q');
  if (sq) {
    sq.addEventListener('input', function () { clearTimeout(searchTimer); searchTimer = setTimeout(function () { runSearch(sq.value); }, 180); });
    sq.form && sq.form.addEventListener('submit', function () { pushRecent(sq.value); });
  }

  function init() {
    initTheme(); initInstall(); applySize(false); initCards(D); initReveal(D); initRails(D); initFx(); initAlerts(); initPdp(); initSizeFilter();
    refreshCartMap();
    if ($('[data-autobag]')) openOv('bag');
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init); else init();

  // Theme editor: re-run the wiring when a section is added or reloaded
  D.addEventListener('shopify:section:load', function (e) { var s = e.target; initCards(s); initReveal(s); initRails(s); initAlerts(); initPdp(); applySize(false); initSizeFilter(); });
})();
